import ApplicationStore from '../../../ApplicationStore'

let agreementPromise: Promise<string | null> | null = null

export const fetchAgreement = async (): Promise<string | null> => {
  if (!agreementPromise) {
    // If no promise is set, create one to fetch the agreement
    agreementPromise = (async () => {
      try {
        const { url } = ApplicationStore.isGetPaidApplication
          ? await ApplicationStore.getInvoicePurchaseAgreement()
          : ApplicationStore.isCreditApplication
          ? await ApplicationStore.getMasterAgreement()
          : { url: null }
        return url
      } catch (error) {
        console.error('Failed to download agreement:', error)
        return null
      }
    })()
  }
  return agreementPromise
}

export const resetAgreementPromise = () => {
  agreementPromise = null
}
